import { render, staticRenderFns } from "./EmergenciaView.vue?vue&type=template&id=8d6345da"
import script from "./EmergenciaView.vue?vue&type=script&lang=js"
export * from "./EmergenciaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports